import React from "react";
import { withRouter } from "react-router-dom";
import { Component } from "react";
import CacheKeys from "../../../cache/CacheKeys";
import CacheManager from "../../../cache/CacheManager";
import LoanStatementPageUI from "./LoanStatementPageUI";

class LoanStatementPageSF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorList: null,
            response: null,
            loanStatementList: null
        };
    }

    render() {
        return (
            <LoanStatementPageUI
                context={this.props.context}
                loanStatementList={this.state.loanStatementList}
                errorList={this.state.errorList}
                onRefreshClick={this.onRefreshClick}
            />
        );
    }

    componentDidMount() {
        let context = this.props.context;
        this.getLoanStatement(context);
    }

    getLoanStatement(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${this.props.match.params.accountId}/loanStatements`,
            cacheKey: CacheKeys.LoanStatements(this.props.match.params.accountId),
            callback: this.getLoanStatementCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getLoanStatementCallback = (response) => {
        this.setState({ errorList: response.errorList, loanStatementList: response.loanStatementList })
    }

    onRefreshClick = () => {
        CacheManager.removeObject(CacheKeys.LoanStatements(this.props.match.params.accountId))
        this.setState({ errorList: null, loanStatementList: null },
            this.getLoanStatement(this.props.context)
        )
    }
}

export default withRouter(LoanStatementPageSF)